module.exports = __webpack_public_path__ + "images/FUSA_icons/012-filter.a5bb34677c824f0c1d8e483d69e7c561.svg";